<footer class="footer">
    <img src="../../../../assets/background/fondo.jpeg" alt="footer" class="img-footer">
    <div class="footer-bg navbar navbar-expand-lg navbar-dark bg-dark">
        <a class="navbar-brand" href="#">
            <img src="../../../../assets/logo_kaza_maya.png" width="30" height="30" alt="">
        </a>
        <span>Teléfono:</span>
        <span class="span-copy">&copy;{{ year }} Kaza Maya</span>
    </div>
</footer>